import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KeywordService } from '@services/keyword.service';
import { KeywordTypeService } from '@services/keywordType.service';
import { PhaseService } from '@services/phase.service';
import { SentenceService } from '@services/sentence.service';
import { UploadService } from '@services/upload.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-newkeyword',
  templateUrl: './newkeyword.component.html',
  styleUrls: ['./newkeyword.component.css']
})
export class NewkeywordComponent implements OnInit {

  definitionForm:FormGroup;
  submitted=false;
  @Input() data:any;
  @Input() phase:any;
  sentences:any[]=[];
  keywordTypes:any[]=[];
  index=0;
  course:any;

  constructor(
    private formBuilder:FormBuilder,
    private activeModal:NgbActiveModal,
    private toastrService: ToastrService,
    private languageService:KeywordService,
    private uploadService:UploadService,
    private sentenceService:SentenceService,
    private keywordTypeService:KeywordTypeService,
    private phaseService:PhaseService
    ) { }

  ngOnInit() {
    console.log(this.phase);
    this.getKeywordTypes();
    this.getCourseData();
    this.definitionForm=this.formBuilder.group({
      'code':['',Validators.required],
      'type':['',Validators.required],
      'shortType':[''],
      'word':['',Validators.required],
      'translate':['',Validators.required],
      'sentence':[''],
      'translatedSentence':[''],
      'phaseId':[this.phase.id],
      'isPremium':[false],
      'hasWallpaper':[true],
      'icon':[''],
      'wallpaper':[''],
      'premiumWallpaper':[''],
      'category':[''],
      'order':['',Validators.required],
      'questionType':["1",Validators.required],
      'option1':[''],
      'option2':[''],
      'option3':[''],
      'youTube':[''],
      'optionMother1':[''],
      'optionMother2':[''],
      'optionMother3': [''],
      'premiumHasText': [false],
      'hasText': [false],
      "licence":['']
    });

    if(this.data){
      this.definitionForm.get("code").patchValue(this.data.code);
      this.definitionForm.get("type").patchValue(this.data.type);
      this.definitionForm.get("shortType").patchValue(this.data.shortType);
      this.definitionForm.get("word").patchValue(this.data.word);
      this.definitionForm.get("translate").patchValue(this.data.translate);
      this.definitionForm.get("sentence").patchValue(this.data.sentence);
      this.definitionForm.get("translatedSentence").patchValue(this.data.translatedSentence);
      this.definitionForm.get("isPremium").patchValue(this.data.isPremium);
      this.definitionForm.get("hasWallpaper").patchValue(this.data.hasWallpaper);
      this.definitionForm.get("category").patchValue(this.data.category);
      this.definitionForm.get("order").patchValue(this.data.order);
      this.definitionForm.get("questionType").patchValue("1");
      this.definitionForm.get("option1").patchValue(this.data.option1);
      this.definitionForm.get("option2").patchValue(this.data.option2);
      this.definitionForm.get("option3").patchValue(this.data.option3);
      this.definitionForm.get("phaseId").patchValue(this.data.phaseId);
      this.definitionForm.get("icon").patchValue(this.data.icon);
      this.definitionForm.get("wallpaper").patchValue(this.data.wallpaper);
      this.definitionForm.get("premiumWallpaper").patchValue(this.data.premiumWallpaper);
      this.definitionForm.get("optionMother1").patchValue(this.data.optionMother1);
      this.definitionForm.get("optionMother2").patchValue(this.data.optionMother2);
      this.definitionForm.get("optionMother3").patchValue(this.data.optionMother3);
      this.definitionForm.get("premiumHasText").patchValue(this.data.premiumHasText);
      this.definitionForm.get("hasText").patchValue(this.data.hasText);
      this.definitionForm.get("youTube").patchValue(this.data.youTube);
      this.definitionForm.get("licence").patchValue(this.data.licence);
   

     
    }

    
  }

  getCourseData(){
    this.phaseService.getCourseData(this.phase.id).subscribe(res=>{
        this.course=res;
    });
  }


  getKeywordTypes(){
    this.keywordTypeService.all(this.phase.id).subscribe(res=>{
      this.keywordTypes=res;
    })
  }


  save(){

   

    if(!this.definitionForm.valid){
      this.definitionForm.markAllAsTouched();
      this.toastrService.clear();
      this.toastrService.warning("Lütfen gerekli alanları doldurunuz","Uyarı");
      return;
    }
    this.submitted=true;


    if(this.data){

      this.languageService.update(this.data.id,this.definitionForm.value).subscribe(res=>{

        this.toastrService.clear();
        this.toastrService.success("Kelime güncelleme başarılı","İşlem Başarılı");
        this.definitionForm.reset();
        this.submitted=false;
        this.files.splice(0, 1);
        this.definitionForm.get("icon").patchValue("");
        this.fileswallpaper.splice(0, 1);
        this.definitionForm.get("wallpaper").patchValue("");
        this.fileslicences.splice(0, 1);
        this.definitionForm.get("licence").patchValue("");
       
      },err=>{
        this.submitted=false;
        this.toastrService.clear();
        this.toastrService.error("Kayıt sırasında hata oluştu","Hata");
      });


    } else {

      console.log(this.definitionForm.value);
      this.languageService.add(this.definitionForm.value).subscribe(res=>{

        this.toastrService.clear();
        this.toastrService.success("Kelime ekleme başarılı","İşlem Başarılı");
        this.definitionForm.reset();
        this.submitted=false;
        this.files.splice(0, 1);
        this.definitionForm.get("icon").patchValue("");
        this.fileswallpaper.splice(0, 1);
        this.definitionForm.get("wallpaper").patchValue("");
        this.fileslicences.splice(0, 1);
        this.definitionForm.get("licence").patchValue("");
        
      
      },err=>{
        this.submitted=false;
        this.toastrService.clear();
        this.toastrService.error("Kayıt sırasında hata oluştu","Hata");
      });
    }
  }





  
  close(){
    this.activeModal.close();
  }


  
  files: File[] = [];

  SelectSingleFile(event) {
    this.files.push(...event.addedFiles);
   
    if(this.files[0].size>4048000){
      this.toastrService.clear();
      this.toastrService.warning("4 MB'dan büyük dosya yükleyemezsiniz.","Uyarı");
      this.files.splice(this.files.indexOf(event), 1);
      return;
    }
    
    var typecodelist=this.keywordTypes.filter(x=>x.name==this.definitionForm.get("type").value);
    var typecode=this.definitionForm.get("type").value;
    if(typecodelist){
      typecode=typecodelist[0].code;
      
    }
    var filename=this.definitionForm.get("code").value;
    if(this.data){
        filename=filename+"_"+typecode+"_"+this.data.level+".png";
    }
    else{
      filename=filename+"_"+typecode+"_"+this.course.level.name+".png";
    }
  
     let formData=new FormData();
     formData.append('file',this.files[0],filename);
      this.uploadService.file(formData,"words").subscribe(res=>{
        this.definitionForm.get("icon").patchValue(res[0]);
      
      },err=>{
        this.toastrService.clear();
        this.toastrService.error("Görsel yüklenirken bir hata oluştu.","Hata");
        this.files.splice(this.files.indexOf(event), 1);
    
      });
    
  
  }
  
  SinglefileonRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
    this.definitionForm.get("icon").patchValue("");
  }



  fileswallpaper: File[] = [];

SelectSingleFileWallpaper(event) {
  this.fileswallpaper.push(...event.addedFiles);
 
  if(this.fileswallpaper[0].size>4048000){
    this.toastrService.clear();
    this.toastrService.warning("4 MB'dan büyük dosya yükleyemezsiniz.","Uyarı");
    this.fileswallpaper.splice(this.fileswallpaper.indexOf(event), 1);
    return;
  }


  
  var typecodelist=this.keywordTypes.filter(x=>x.name==this.definitionForm.get("type").value);
  var typecode=this.definitionForm.get("type").value;
  if(typecodelist){
    typecode=typecodelist[0].code;
  }
  var filename=this.definitionForm.get("code").value;
  if(this.data){
      filename=filename+"_"+typecode+"_"+this.data.level+".png";
  }
  else{
    filename=filename+"_"+typecode+"_"+this.course.level.name+".png";
  }

   let formData=new FormData();
   formData.append('file',this.fileswallpaper[0],   filename);
    this.uploadService.file(formData,"wallpapers").subscribe(res=>{
      this.definitionForm.get("wallpaper").patchValue(res[0]);
   
    },err=>{
      this.toastrService.clear();
      this.toastrService.error("Görsel yüklenirken bir hata oluştu.","Hata");
      this.fileswallpaper.splice(this.fileswallpaper.indexOf(event), 1);
    
    });
  

}

SinglefileonRemovewallpaper(event) {
  this.fileswallpaper.splice(this.fileswallpaper.indexOf(event), 1);
  this.definitionForm.get("wallpaper").patchValue("");
}





filespremiumwallpaper: File[] = [];

SelectSingleFilePremiumWallpaper(event) {
  this.filespremiumwallpaper.push(...event.addedFiles);
 
  if(this.filespremiumwallpaper[0].size>4048000){
    this.toastrService.clear();
    this.toastrService.warning("4 MB'dan büyük dosya yükleyemezsiniz.","Uyarı");
    this.filespremiumwallpaper.splice(this.filespremiumwallpaper.indexOf(event), 1);
    return;
  }


   let formData=new FormData();
   formData.append('file',this.filespremiumwallpaper[0],this.filespremiumwallpaper[0].name);
    this.uploadService.file(formData,"premiumwallpapers").subscribe(res=>{
      this.definitionForm.get("premiumwallpaper").patchValue(res[0]);
   
    },err=>{
      this.toastrService.clear();
      this.toastrService.error("Görsel yüklenirken bir hata oluştu.","Hata");
      this.filespremiumwallpaper.splice(this.filespremiumwallpaper.indexOf(event), 1);
    
    });
  

}

SinglefileonRemovepremiumwallpaper(event) {
  this.filespremiumwallpaper.splice(this.filespremiumwallpaper.indexOf(event), 1);
  this.definitionForm.get("premiumwallpaper").patchValue("");
}


  wordChange(){
    this.sentences=[];
    this.definitionForm.get("sentence").patchValue("");
    this.definitionForm.get("translatedSentence").patchValue("");
    this.index=0;
  
  }

  getSampleSentence(){
    if(this.sentences.length==0 && this.definitionForm.get("word").value!=""){
      this.sentenceService.get(this.definitionForm.get("word").value,this.course.from.apiCode,this.course.to.apiCode).subscribe(res=>{
        this.sentences=res.results;
        var sent=this.sentences[this.index];
        this.definitionForm.get("sentence").patchValue(sent.text);
        this.definitionForm.get("translatedSentence").patchValue(sent.translations[0][0].text);
        this.index++;
      });
     
    }
    else{
      this.getSentence();
    }
  }

  getSentence(){
    if(this.index==this.sentences.length){
      this.index=0;
    }

    var sent=this.sentences[this.index];
    this.definitionForm.get("sentence").patchValue(sent.text);
    this.definitionForm.get("translatedSentence").patchValue(sent.translations[0][0].text);
    this.index++;
  }





  fileslicences: File[] = [];

  SelectSingleFileLicence(event) {
    this.fileslicences.push(...event.addedFiles);

    if (this.fileslicences[0].size > 4048000) {
      this.toastrService.clear();
      this.toastrService.warning("4 MB'dan büyük dosya yükleyemezsiniz.", "Uyarı");
      this.fileslicences.splice(this.fileslicences.indexOf(event), 1);
      return;
    }



    var typecodelist = this.keywordTypes.filter(x => x.name == this.definitionForm.get("type").value);
    var typecode = this.definitionForm.get("type").value;
    if (typecodelist) {
      typecode = typecodelist[0].code;
    }
    var filename = this.definitionForm.get("code").value;
    if (this.data) {
      filename = filename + "_" + typecode + "_" + this.data.level + ".pdf";
    }
    else {
      filename = filename + "_" + typecode + "_" + this.course.level.name + ".pdf";
    }

    let formData = new FormData();
    formData.append('file', this.fileslicences[0], filename);
    this.uploadService.file(formData, "licence").subscribe(res => {
      this.definitionForm.get("licence").patchValue(res[0]);

    }, err => {
      this.toastrService.clear();
      this.toastrService.error("Pdf yüklenirken bir hata oluştu.", "Hata");
      this.fileslicences.splice(this.fileslicences.indexOf(event), 1);

    });


  }

  SinglefileonRemovelicence(event) {
    this.fileslicences.splice(this.fileslicences.indexOf(event), 1);
    this.definitionForm.get("licence").patchValue("");
  }


}
